// import { useState } from "react";
// import {
//   fetchExhibitorCategories,
//   fetchExhibitorCategoryById,
//   createExhibitorCategory,
//   updateExhibitorCategory,
//   deleteExhibitorCategory,
//   fetchExhibitorCategoriesTree
// } from "../../../api/exhibitorCategory.api";

// export const useExhibitorCategory = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const loadCategories = async (companyId) => {
//     setLoading(true);
//     const res = await fetchExhibitorCategories(companyId);
//     setData(res.data?.data || []);
//     setLoading(false);
//   };

//   const loadCategoryById = async (id) => {
//     const res = await fetchExhibitorCategoryById(id);
//     return res.data?.data;
//   };

//   const loadCategoryByOrganizer = async (company_id) => {
//     setLoading(true);
//     const res = await fetchExhibitorCategoriesTree({ company_id });
//     setData(res.data?.data || []);
//     setLoading(false);
//   };

//   const addCategory = (payload) => createExhibitorCategory(payload);
//   const editCategory = (id, payload) => updateExhibitorCategory(id, payload);
//   const removeCategory = (id, payload) => deleteExhibitorCategory(id, payload);

//   return {
//     data,
//     loading,
//     loadCategories,
//     loadCategoryById,
//     addCategory,
//     editCategory,
//     removeCategory,
//     loadCategoryByOrganizer
//   };
// };
import { useState } from "react";
import {
  fetchExhibitorCategories,
  fetchExhibitorCategoryById,
  createExhibitorCategory,
  updateExhibitorCategory,
  deleteExhibitorCategory,
  fetchExhibitorCategoriesTree,
} from "../../../api/exhibitorCategory.api";

export const useExhibitorCategory = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    totalCategories: 0,
    totalPages: 1,
  });

  const loadCategories = async (companyId) => {
    setLoading(true);
    try {
      const res = await fetchExhibitorCategories(companyId);
      setData(res.data?.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadCategoryById = async (id) => {
    const res = await fetchExhibitorCategoryById(id);
    return res.data?.data;
  };

  const loadCategoryByOrganizer = async (company_id, options = {}) => {
    if (!company_id) return;
    setLoading(true);
    try {
      const res = await fetchExhibitorCategoriesTree({
        company_id,
        page: options.page || 1,
        limit: options.limit || 10,
        search: options.search || "",
      });

      const payload = res?.data || {};
      const list =
        payload.categories ||
        payload.data?.categories ||
        payload.data ||
        (Array.isArray(payload) ? payload : []);

      setData(list);

      setPaginationInfo({
        totalCategories:
          payload.pagination?.totalCategories || payload.total || list.length,
        totalPages: payload.pagination?.totalPages || payload.totalPages || 1,
      });
    } catch (error) {
      console.error("Error fetching exhibitor category tree:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const addCategory = (payload) => createExhibitorCategory(payload);
  const editCategory = (id, payload) => updateExhibitorCategory(id, payload);
  const removeCategory = (id, payload) => deleteExhibitorCategory(id, payload);

  return {
    data,
    loading,
    paginationInfo,
    loadCategories,
    loadCategoryById,
    addCategory,
    editCategory,
    removeCategory,
    loadCategoryByOrganizer,
  };
};